import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { CustomFacade, getRolesAndPermission } from '@piqet-angular/data';
import { right } from '@popperjs/core';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class CustomTrucksDataGridService {
  customTruckPayload: any;
  event: any;
  Access: any;
  editData = new Subject<[any, any, any]>();
  customTrucksObservable$ = this.editData.asObservable();

  deletetruckData = new Subject<[any, any, any]>();
  truckDeleteObservable$ = this.deletetruckData.asObservable();

  copyTruck = new Subject<[any, any, any]>();
  copyTruckObservable$ = this.copyTruck.asObservable();

  inlineEditing = new Subject<[any, any]>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();
  currentRoute: string = '';
  constructor(private swalService: SwalService, private accessService: AccessPermissionService) {}

  accessAllPermission(type: string) {
    const access =
      this.isAccess(type, 'edit') || this.isAccess(type, 'delete') || this.isAccess(type, 'create');
    return access;
  }

  getCustomTrucksDataColumn(pathName?: any): ColDef[] {
    this.currentRoute = pathName;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'My custom trucks',
      field: 'name',
      minWidth: grid_widths_map.lg_column_xxl,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        const checkAccess = this.isAccess(pathName, 'edit') || this.isAccess(pathName, 'view');
        if (checkAccess) {
          cellElement.title = dblclickTooltipDef;
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess && this.editData.next([params.data.truckId, 'Review custom truck', pathName]);
        });
        return cellElement;
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    {
      pathName == 'adminCustomTrucks' &&
        colDef.push({
          ...defaultColumn,
          colId: 'OrganizationName',
          headerName: 'Organization name',
          field: 'organizationName',
          cellClass: 'my-permission-cursor-pointer',
          minWidth: grid_widths_map.sm_column_sm,
          wrapText: true,
          autoHeight: true,
          lockVisible: true,
          filter: 'agTextColumnFilter',
          resizable: false,
        });
    }

    colDef.push({
      ...defaultColumn,
      colId: 'OwnerName',
      headerName: 'Owner',
      field: 'owner',
      cellClass: 'my-permission-cursor-pointer',
      minWidth: grid_widths_map.sm_column_xm,
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    this.accessAllPermission(pathName) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellRendererParams: {
          showEdit: this.isAccess(pathName, 'edit'),
          showCopy: this.isAccess(pathName, 'create'),
          showDelete: this.isAccess(pathName, 'delete'),
          value: 'customTruck',
          deleteData: (data: any, pathName: any) => {
            if (pathName === 'adminCustomTrucks') {
              this.deleteCustomDataConfirmation(
                data,
                '/AdminCustomTruck/DeleteCustomTruck',
                pathName
              );
            } else {
              this.deleteCustomDataConfirmation(data, '/CustomTruck/DeleteCustomTruck', pathName);
            }
          },
          copyData: (data: any, pathName: any) => {
            if (pathName === 'adminCustomTrucks') {
              this.copyTruck.next([data, '/AdminCustomTruck/SaveCloneTruck', pathName]);
            } else {
              this.copyTruck.next([data, '/CustomTruck/SaveCloneTruck', pathName]);
            }
          },
          editData: (data: any, pathName: any) => {
            this.editData.next([data.truckId, 'Review custom truck', pathName]);
          },
        },
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName.includes('admin')
      ? this.accessService.hasModulePermission(
          rolesModuleName.AdministratorTrucks,
          mainModuleName.projectManagementModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.customTrucks,
          mainModuleName.customModule,
          type
        );
  };

  deleteCustomDataConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deletetruckData.next([data, customType, pathName]);
      }
    });
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getCustomTrucksDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.customTruckPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'name',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  isEmpty(val: any) {
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }
}
